import JobWorkerInterviewStatus from "@/models/JobWorkerInterviews/JobWorkerInterviewStatus";

export default (value: JobWorkerInterviewStatus) => {
    switch (value) {
        case JobWorkerInterviewStatus.PendingConfirmation:
            return "Pending";
        case JobWorkerInterviewStatus.FullyConfirmed:
            return "Fully Confirmed";
        case JobWorkerInterviewStatus.PartiallyConfirmed:
            return "Partially Confirmed";
        case JobWorkerInterviewStatus.Completed:
            return "Completed";
        case JobWorkerInterviewStatus.Cancelled:
            return "Cancelled";
        default:
            return "Unknown";
    }
} 